import { __makeTemplateObject } from '../../../../node_modules/tslib/tslib.es6.js';
import styled, { css } from 'styled-components';
import { color } from '../../../styles/styles.js';
var StyledAlert = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n\n  border-style: solid;\n  border-width: 10px 1px 1px 1px;\n  background-color: ", ";\n  border-color: ", ";\n  header {\n    margin-top: 0;\n    margin-bottom: 10px;\n    display: inline-flex;\n    align-content: center;\n    font-size: 14px;\n  }\n  svg.notification-icon {\n    width: 20px;\n    min-width: 20px;\n    height: 20px;\n    margin-right: 5px;\n    color: ", ";\n  }\n  padding: 10px;\n  ", "\n"], ["\n  color: ", ";\n\n  border-style: solid;\n  border-width: 10px 1px 1px 1px;\n  background-color: ", ";\n  border-color: ", ";\n  header {\n    margin-top: 0;\n    margin-bottom: 10px;\n    display: inline-flex;\n    align-content: center;\n    font-size: 14px;\n  }\n  svg.notification-icon {\n    width: 20px;\n    min-width: 20px;\n    height: 20px;\n    margin-right: 5px;\n    color: ", ";\n  }\n  padding: 10px;\n  ", "\n"])), function (props) {
  return props.theme === 'dark' ? color.medium : color.darker;
}, function (props) {
  return props.theme === 'dark' ? color.darkModeDark : '#fff';
}, function (props) {
  switch (props.fcStyle) {
    case 'danger':
      return color.danger;

    case 'warning':
      return color.warning;

    case 'info':
      return color.info;

    case 'success':
      return color.success;

    default:
      return props.theme === 'dark' ? '#fff' : color.dark;
  }
}, function (props) {
  switch (props.fcStyle) {
    case 'danger':
      return color.danger;

    case 'warning':
      return color.warning;

    case 'info':
      return color.info;

    case 'success':
      return color.success;

    default:
      return props.theme === 'dark' ? '#fff' : color.dark;
  }
}, function (props) {
  return props.borderRadius && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-radius: 5px;\n    "], ["\n      border-radius: 5px;\n    "])));
});
var Title = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  top: -5px;\n  margin-left: 5px;\n  font-size: 14px;\n  display: inline-block;\n  font-weight: bold;\n  display: inline-block;\n"], ["\n  top: -5px;\n  margin-left: 5px;\n  font-size: 14px;\n  display: inline-block;\n  font-weight: bold;\n  display: inline-block;\n"])));
var AlertContent = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (props) {
  return props.theme === 'dark' ? '#fff' : color.dark;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
export { AlertContent, StyledAlert, Title };